module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "chapterBoards"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v("Chapter Boards")]), _vm._v(" "), _vm._l((_vm.boards), function(board) {
    return _c('div', [_c('h4', {
      domProps: {
        "innerHTML": _vm._s(board.board_name)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "board"
    }, _vm._l((board.board_members), function(boardMember) {
      return _c('div', [_c('h5', {
        domProps: {
          "innerHTML": _vm._s(boardMember.name)
        }
      }), _vm._v(" "), _c('p', {
        domProps: {
          "innerHTML": _vm._s(boardMember.organization)
        }
      })])
    }))])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5129102c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OurTeam/ChapterBoards.vue
// module id = 318
// module chunks = 1